import { Autocomplete, Paper } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const StyledAutocomplete = styled(Autocomplete)`
  max-width: 300px;
  height: 40px;
  flex-grow: 1;
  background: transparent;
  border: 1px solid ${theme.colors.controlBorder};
  border-radius: ${theme.attributes.borderRadius.large};

  html[data-theme='light'] &:not(.Mui-focused) {
    border-color: ${theme.colors.dropdownBorder};
  }
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${theme.colors.devicesSecondaryText};

  &.Mui-focused {
    border: 1px solid ${theme.colors.cta};
    border-radius: ${theme.attributes.borderRadius.quaternary} ${theme.attributes.borderRadius.quaternary} 0 0 !important;
    border-bottom: none !important;

    fieldset {
      border: none;
      border-bottom: none !important;
    }
  }

  .MuiOutlinedInput-root {
    padding: 0 ${theme.spacing.small}px;
    height: 40px;
    color: #e3e3e3;

    html[data-theme='light'] & {
      color: ${theme.colors.menuItemText};
    }

    .MuiAutocomplete-endAdornment {
      .MuiButtonBase-root {
        padding: ${theme.spacing.xsm}px;

        &:hover {
          background: rgba(202, 196, 208, 0.08);
        }

        svg {
          path {
            fill: ${theme.colors.devicesSecondaryText};
          }
        }
      }
    }

    .MuiOutlinedInput-input {
      padding-left: ${theme.spacing.sm}px;
      padding-top: 0;
      padding-bottom: 0;
      height: 40px;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 20px;
      letter-spacing: 0.1px;

      &::placeholder {
        opacity: 1;
        color: ${theme.colors.devicesSecondaryText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 20px;
        letter-spacing: 0.1px;
      }
    }

    &::placeholder {
      opacity: 1;
    }

    fieldset {
      border: none;
    }
  }
`

export const PaperComponent = styled(Paper)`
  width: 300px;
  border-radius: 0 0 ${theme.attributes.borderRadius.quaternary} ${theme.attributes.borderRadius.quaternary} !important;
  background: ${theme.colors.backgroundMedium};
  padding: 0;
  border: 1px solid ${theme.colors.cta};
  border-top: none !important;
  margin-top: -1px;
  margin-left: -1px;

  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
  }

  ul {
    li {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.bold};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      line-height: 20px;
      letter-spacing: 0.1px;

      html[data-theme='light'] & {
        color: ${theme.colors.menuItemText};
      }

      &:hover {
        html[data-theme='light'] & {
          background: ${theme.colors.menuItemHover};
        }
      }

      svg {
        margin-right: ${theme.spacing.xSmall}px;
      }
    }
  }
`
